import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from './location.service';

@Component({
  selector: 'fl-location',
  template: `
    <ng-container></ng-container>
  `,
})
// This component pushes new locations to the Location service and must be
// imported by the root app component, as this can't be done from services in
// Angular
export class LocationComponent implements OnInit {
  constructor(private router: Router, private location: Location) {}

  ngOnInit() {
    this.location._routeHasLoaded();
    this.router.events.subscribe(event => {
      // push new location to Location service
      if (event instanceof NavigationEnd) {
        this.location._setLocation(event.url);
      }
    });
  }
}
